<template>
  <div class="animated fadeIn">
    <loader :show="enviando"/>
    <b-row>
      <b-col  sm="12" md="12">
        <b-card header-tag="header" >
   
          <div slot="header">
            <b-button  @click="regresar()" size="sm" variant="secondary"> Regresar a expedientes  </b-button>
          </div>
          <div slot="header"  style="text-align:center;">
            <strong >Actas de expediente {{expediente.folio}} </strong>
          </div>
          <b-row>
          <b-col v-if="expediente.actas.length === 0" sm="12" md="12">
              <p >No hay actas capturadas</p>
          </b-col>
          <b-col v-else >
              <v-client-table    
                :columns="tabla.columns" 
                :data="expediente.actas" 
                :options="tabla.options">
                <div style="min-width:fit-content; " slot="options" slot-scope="props" >
                  <b-dropdown
                    v-if="puedeAdministrar" 
                    id="ddown1" 
                    size="sm" 
                    variant="outline-primary" 
                    text="Opciones">
                    <!--ponerle permisos a los dropdown-->
                    <b-dropdown-item @click="verActa(props.row._id)">Ver acta</b-dropdown-item>
                    <b-dropdown-item v-if="puedeAdministrar" :disabled="props.row.conclusion!='En proceso'"   @click="modificarActa(props.row._id)">Editar acta</b-dropdown-item>
                    <b-dropdown-item :disabled="props.row.conclusion =='En proceso'" @click="printQR(props.row.folio, props.row.descarga)">QR</b-dropdown-item>
                    
                    <b-dropdown-item v-if="puedeConcluir" :disabled="props.row.conclusion !='En proceso'" @click="concluir(props.row._id)">Concluir acta</b-dropdown-item>
                    <b-dropdown-item v-if="puedeDictaminar" :disabled="props.row.conclusion=='En proceso'" @click="download(props.row._id)">Dictaminar</b-dropdown-item>
                    <b-dropdown-item v-if="puedeDescargar" :disabled="props.row.conclusion =='En proceso'" @click="down(props.row._id)">Acta circunstancial</b-dropdown-item>
                  </b-dropdown>
                </div>
              </v-client-table>

            
            </b-col>
            <b-col v-if="puedeAdministrar" md="12">
              <b-button 
                size="sm" 
                variant="primary"
                @click="mostrar=true">
                Nueva acta
              </b-button>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
   
    <b-modal v-model="cargandoQR" size="xs" title="Descargar QR" hide-footer  hide-header-close no-close-on-backdrop  >  
      <b-row>
      <b-col sm="12" style="text-align: -webkit-center;">
        <div ref="printMe"  style="width:250px; text-align: center"  >
        <b-card-text> Escanea QR e ingresa los datos de este talón para descargar el acta</b-card-text>      
        <b-card-text> Clave: <b> {{ pass }}</b> </b-card-text>
        <b-card-text> https://www.elsalto.gob.mx/proteccion-civil </b-card-text>      
        <img src='../../../public/img/brand/qr.jpg' width="217" height="217">      
        </div>
      </b-col>
      </b-row>
      <b-row>      
      <b-col style="text-align: center">
      <b-button size="sm" @click="cargandoQR=false">Cancelar</b-button>
      <br />
      </b-col>
      <b-col style="text-align: center">
      <b-button  size="sm" variant="primary"  @click="print()">Descargar</b-button>
      </b-col>
      </b-row>
    </b-modal>
       
    <agregarActa
        v-if="mostrar"
        :mostrar='mostrar'
        :cuenta="cuenta"
        :idExpediente="expediente._id"
        :editarActa="editarActa"
        @cancelar="mostrar=false, editarActa=null"
        @guardar="guardar"
        @actualizar="actualizar"
      />
      <descargarActa
        v-if="prepararDescarga "
        :mostrar="prepararDescarga"
        :idExpediente="expediente._id"
        :idActa="idActa"
        :idCuenta="$route.params.idCuenta"
        @cancelar="prepararDescarga=false"
       
      />
  </div>
</template>

<script>
import axios from 'axios'
import Loader from '../Loader'
import agregarActa from './agregarActa'
import descargarActa from './descargar'
import { mapGetters } from "vuex";
const { DateTime } = require("luxon");

export default {
  name: 'listadoActas',
  components: { Loader, agregarActa, descargarActa },
  computed: {
    ...mapGetters(["httpURL",  "sessionToken",  "permisos",  "role"]),
    puedeAdministrar(){
      if( this.role == 'administrador' || this.permisos.findIndex(x => x.numero === 219) != -1 )
        return true;
      else return false;
    },
   
   puedeConcluir(){
      if( this.role == 'administrador' || this.permisos.findIndex(x => x.numero === 221) != -1 )
        return true;
      else return false;
    },
    puedeDictaminar(){
      if( this.role == 'administrador' || this.permisos.findIndex(x => x.numero === 225) != -1 )
        return true;
      else return false;
    },
    puedeDescargar(){
      if( this.role == 'administrador' || this.permisos.findIndex(x => x.numero === 226) != -1 )
        return true;
      else return false;
    },
  },
  data: function () {
    return {
        folio:'',
        cargandoQR:false,
        enviando: false,
        cuenta: null,
        expediente:{_id:null, folio:null, actas:[]},
        mostrar:false,
        idActa:null,
        tabla: {
         
          columns: ['options','folio', 'conclusion'],
          options: {
            headings: {
              options: '',
              folio: 'FOLIO',
              conclusion: 'Status',
             
            }, 
            perPage: 20,
            perPageValues: [10, 20, 30, 50, 100],
            resizableColumns:false,
            texts: {
                  count: "Mostrando del {from} al {to} de {count} registros|{count} registros|Único registro",
                  first: 'Primero',
                  last: 'Último',
                  filter: "Buscar:",
                  filterPlaceholder: "Ingrese...",
                  limit: "Registros:",
                  page: "Página:",
                  noResults: "No hay registros.",
                  filterBy: "Filtrando por {column}",
                  loading: 'Cargando...',
                  defaultOption: 'Select {column}',
                  columns: 'Columns'
              }
        }
        },
        editarActa:null,
        idActa:null,
        prepararDescarga:false,
        pass:null,

    }
  },
  created(){
    //Se obtienen los elementos del menú
    if( this.role != 'administrador' && this.permisos.findIndex(x => x.numero === 218) != -1)
    //this.$router.go(-1);
    this.enviando = true;
    
    axios.get(this.httpURL+'/proteccionBomberos/cuenta/'+this.$route.params.idCuenta+'/expediente/'+this.$route.params.id+'/actas',
        {headers:{token:this.sessionToken}})
        .then(res => {
         // console.log(res.data);
         //console.log(DateTime.fromISO(this.acta.conclusion).toFormat('yyyy-MM-dd'));
          this.cuenta = res.data.cuenta;
          this.expediente= res.data.expediente;
          if(this.expediente.actas.length>0){
            this.expediente.actas.forEach(acta=>{
              acta.conclusion= acta.conclusion ? `Concluida el ${ DateTime.fromISO(acta.conclusion).toFormat('dd-MM-yyyy')}` : 'En proceso'           })
          }
          
          this.enviando = false;
        })
        .catch(error => {
          this.enviando = false;
          //console.log(error);
           swal("Oops!",'No se pudo establecer una conexión al servidor. \nVerifique su conexión a internet.' , "error")
           this.enviando = false;
        });
  },
  methods: {

    printQR(folio,descarga){
      this.cargandoQR=true
      this.pass=descarga
    },
    async print() {
           
      const el = this.$refs.printMe;
      const options = { type: 'dataURL' }
      this.output = await this.$html2canvas(el, options);
      var element = document.createElement("a");
      element.setAttribute("href", this.output);
      element.setAttribute("download", 'qr');
      element.style.display = "none";
      document.body.appendChild(element);
      element.click();
      document.body.removeChild(element);
      this.cargandoQR=false
    },
   
   
    regresar(){
         this.$router.replace({path: '/proteccionBomberos/cuenta/'+this.$route.params.idCuenta+'/expedientes'});
      },
    verActa(id){
      this.$router.replace({path: '/proteccionBomberos/cuenta/'+this.$route.params.idCuenta+'/expediente/acta/'+id});
    },
    modificarActa(id){
      this.editarActa = this.expediente.actas.find(x => x._id.toString() == id)
      this.mostrar = true;
    },
    guardar(data){
      this.mostrar = false;
      let nueva ={...data }
      nueva.conclusion = 'En proceso'
      this.expediente.actas.push(nueva) 
    },
    actualizar(data){
      this.mostrar = false;
       let index = this.expediente.actas.findIndex(x =>x._id.toString()==data._id)
      if(index !== -1) {
        this.expediente.actas.splice(index,1,data)
         this.expediente.actas[index].conclusion = 'En proceso'
      }

    },
    concluir(id){
      
      this.enviando = true;
      axios.put(this.httpURL+'/proteccionBomberos/expediente/acta/concluir/'+id,
        {},
        {headers:{token:this.sessionToken}})
        .then(res => {
          this.enviando = false;
          if(res.data.ok){
          let index = this.expediente.actas.findIndex(x =>x._id.toString()==id)
          if(index !== -1) this.expediente.actas[index].conclusion = `Concluida el ${ DateTime.fromISO(res.data.conclusion).toFormat('dd-MM-yyyy')}` 
          }
        })
        .catch(error => {
          //console.log(error);
          this.enviando = false;
           swal("Oops!",'No se pudo establecer una conexión al servidor. \nVerifique su conexión a internet.' , "error")
           this.enviando = false;
        });

      
    },
    download(id){
      this.idActa=id
      this.prepararDescarga=true;
    },
    down(id){
      
       this.enviando=true;
        axios({
          url: `${this.httpURL}/proteccionBomberos/cuenta/descargarActa/${id}`,
          method: 'POST',
          responseType: 'blob', // important
          data: { },
          headers:{token:this.sessionToken}
          })
          .then(response => {
            //console.log(response);
             this.enviando=false
              let blob = new Blob([response.data], { type: 'application/pdf' }),
              url = window.URL.createObjectURL(blob);
              var a = document.createElement("a");
              document.body.appendChild(a);
              a.href = url;
              a.download = `ActaConstitutiva.pdf`             
              a.click();
              window.URL.revokeObjectURL(url);

             // this.$emit('cancelar')

              })
          .catch(error => {
              //console.log(error);
              this.enviando = false;
              
              if(error.response){
                  this.$notify({ group: 'foo', type:"error", duration:2500, speed: 1000,
                          text: error.response.data.mensaje });
              }else if( error.request){
                  this.$notify({ group: 'foo', type:"error", duration:1500, speed: 1000,
                          text: 'No se pudo establecer una conexión al servidor.' });
              }
          });
    }
    
    }
}
</script>



<style >
.table-responsive {
  overflow-x: visible !important ;
}
</style>